// extracted by mini-css-extract-plugin
export default {"content":"invite-page_content__mzJBT","input":"invite-page_input__jH+9b"};